import { useEffect, useRef, useState } from "react";
import logo from "../../../assets/logo.svg";
import L from "../../../constants/baysportLabels";
import s from "./adminApp.module.css";

export function AdminSplashStatic() {
  return <div className={s.splashStatic} role="status" aria-label="Загрузка" />;
}

const TIMING = {
  text: 1200,
  exit: 2700,
  done: 3600,
};

export default function AdminSplash({ clubName, onComplete }) {
  const [phase, setPhase] = useState("logo");
  const onCompleteRef = useRef(onComplete);
  onCompleteRef.current = onComplete;

  useEffect(() => {
    const toText = setTimeout(() => setPhase("text"), TIMING.text);
    const toExit = setTimeout(() => setPhase("exit"), TIMING.exit);
    const finish = setTimeout(() => onCompleteRef.current?.(), TIMING.done);
    return () => {
      clearTimeout(toText);
      clearTimeout(toExit);
      clearTimeout(finish);
    };
  }, []);

  return (
    <div
      className={s.splash}
      data-phase={phase}
      role="status"
      aria-live="polite"
      aria-label="Загрузка"
    >
      <div className={s.splashBg} aria-hidden />
      <div className={s.splashStage}>
        <div className={s.splashLogoLayer} aria-hidden={phase !== "logo"}>
          <div className={s.splashLogoCard}>
            <img src={logo} alt="" className={s.splashLogo} width={72} height={72} />
          </div>
        </div>
        <div className={s.splashTextLayer} aria-hidden={phase === "logo"}>
          <h1 className={s.splashBrand}>{L.productName}</h1>
          <p className={s.splashTagline}>{clubName || "Панель управления"}</p>
        </div>
      </div>
    </div>
  );
}
